import * as api from "../api";

export const getUser = (id) => async (dispatch) => {
  try {
    const { data } = await api.getUser(id);

    dispatch({ type: "GET_USER", payload: data[0] });
  } catch (error) {
    console.log(error.message);
  }
};

export const createUser = (newUser) => async (dispatch) => {
  try {
    const { data } = await api.createUser(newUser);

    dispatch({ type: "CREATE_USER", payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const updateUser = (id, updatedUser) => async (dispatch) => {
  console.log("UPDATING", updatedUser);
  try {
    const { data } = await api.updateUser(id, updatedUser);
    dispatch({ type: "UPDATE_USER", payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const signIn = () => {
  return { type: "SIGN_IN" };
};

export const signOut = () => {
  return { type: "SIGN_OUT" };
};

export const createGame = (game) => {
  return { type: "CREATE_GAME", payload: game };
};

export const deleteGame = () => {
  return { type: "DELETE_GAME" };
};

export const savePrevGame = (game) => {
  return { type: "SAVE_PREV_GAME", payload: game };
};
